module.exports = __webpack_public_path__ + "img/space-generic-1.dc19556b.jpg";